import React from 'react';

export default function PainelIndicadoresPage() {
  return (
    <div>
      Qualidade - Painel de Indicadores (placeholder).
    </div>
  );
}

